"use client";

import React, { useState, useRef } from 'react';
import VideoModal from '@components/molecules/VideoModal/VideoModal';
import { DeviceType } from '@interfaces/video';
import { createVideoSource } from '@utils/videoUtils';
import { EventType, trackEventWithCommonProps } from '@utils/eventTracker';
import { PAGE_TYPES } from '@constants/pageTypes';

interface VideoModalWrapperProps {
  children: React.ReactElement;
  cityName?: any;
  metaData?: any;
  videoUrl?: any;
}

const VideoModalWrapper: React.FC<VideoModalWrapperProps> = ({ children, cityName, metaData, videoUrl }) => {
  const [isVideoModalOpen, setisVideoModalOpen] = useState<boolean>(false);
  const videoTimeRef = useRef<{ currentTime: number; duration: number }>({ currentTime: 0, duration: 0 });

  const handleModalClose = async () => {
    setisVideoModalOpen(false);
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: PAGE_TYPES.HOME_PAGE,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_close_expert_video",
        city_name: cityName,
        closing_time: Math.floor(videoTimeRef.current.currentTime),
        total_time: Math.floor(videoTimeRef.current.duration)
      },
    });
  };

  const handleOpenModal = async () => {
    setisVideoModalOpen(true);
    // Reset video time tracking when opening modal
    videoTimeRef.current = { currentTime: 0, duration: 0 };
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: PAGE_TYPES.HOME_PAGE,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_expert_video",
        city_name: cityName,
      },
    });
  };

  const handleTimeUpdate = (currentTime: number, duration: number) => {
    videoTimeRef.current = { currentTime, duration };
  };

  return (
    <>
      {React.cloneElement(children, { 
        onClick: handleOpenModal 
      } as any)}
      <VideoModal
        video={createVideoSource(videoUrl)}
        metadata={metaData}
        isOpen={isVideoModalOpen}
        onClose={handleModalClose}
        deviceType={DeviceType.DESKTOP}
        config={{
          autoplay: true,
          muted: false,
          showTitle: true,
          showProgress: true,
          showVolume: true,
          showClose: true,
        }}
        events={{
          onPlay: () => console.log("Video started playing"),
          onPause: () => console.log("Video paused"),
          onEnded: () => console.log("Video ended"),
          onError: (error) => console.error("Video error:", error),
          onTimeUpdate: handleTimeUpdate,
        }}
      />
    </>
  );
};

export default VideoModalWrapper; 